import type { AuthAdapter } from '@/core/types/auth.types';

let _adapter: AuthAdapter | null = null;

export function setAuthAdapter(adapter: AuthAdapter): void {
  _adapter = adapter;
}

export function getAuthAdapter(): AuthAdapter {
  if (!_adapter) throw new Error('AuthAdapter has not been registered');
  return _adapter;
}
